import React from 'react';
import styled from 'styled-components';
import i18next from 'i18next';
import { Columns, Column, LevelItem, LevelLeft, LevelRight } from 'bloomer';
import Popup from '../Popup/Popup';
import CreateProfile from '../CreateProfile/CreateProfile';
import PrimaryButton from '../PrimaryButton/PrimaryButton';
import Icon from '../Icon/Icon';

interface CreateProfileStates {
  isOpen?: boolean;
}
interface CreateUserBarProps {
  onLoadKits: () => Promise<void>;
}
class CreateUserBarView extends React.PureComponent<CreateUserBarProps, CreateProfileStates> {

  state: CreateProfileStates = {
    isOpen: false,
  };

  render() {

    return (
      <div>
        {
          this.state.isOpen ?
            <Popup>
              <CreateProfile hidePopup={this.hideProfilePopup} {...this.props} />
            </Popup> : undefined
        }

        <RoundBorderContainer>
          <Columns>
            <Column>
              <LevelLeft>
                <LevelItem>
                  <OverviewStatusLabel>{i18next.t('cmp.createProfile.title')}</OverviewStatusLabel>
                </LevelItem>
              </LevelLeft>
            </Column>
            <Column>
              <LevelRight>
                <LevelItem>
                  <PrimaryButton onClick={() => this.createProfilePopup()}>
                    <Icon icon="plus" />&nbsp;&nbsp;+ Create
                  </PrimaryButton>
                </LevelItem>
              </LevelRight>
            </Column>
          </Columns>
        </RoundBorderContainer >
      </div>
    );
  }
  createProfilePopup = () => {
    this.setState({ isOpen: true });
  };
  hideProfilePopup = (reload: boolean) => {
    this.setState({ isOpen: false });
    if (reload)
      this.props.onLoadKits();
  }
}

const RoundBorderContainer = styled.div`
  background: white;
  border-radius: 1em;
  padding: 0.9rem;
  margin-right: 1.5rem;
  margin-bottom:1em;
  align-items: center;
`;

const OverviewStatusLabel = styled.div`
  font-size: 1.5rem;
  font-weight: 100;
`;
export default CreateUserBarView;